import * as React from "react";
const IconMenuAlt1 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M12.9 31c-.6 0-1 .4-1 1s.4 1 1 1h38.2c.6 0 1-.4 1-1s-.4-1-1-1zM61 48.7H3c-.6 0-1 .4-1 1s.4 1 1 1h58c.6 0 1-.4 1-1s-.4-1-1-1M3 15.3h58c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1s.4 1 1 1" />
  </svg>
);
export default IconMenuAlt1;
